import Icon from '@xo-union/tk-component-icons';
import { Body1 } from '@xo-union/tk-ui-typography';
import React from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';

import shared from './infoHeader.scss';
import styles from './url.scss';

interface Props {
  onCopy: () => void;
  url: string;
  className?: string;
  copyCta?: string;
}

const UrlCopy: React.FC<Props> = ({ onCopy, url, copyCta, className = '' }) => {
  return (
    <div className={`${styles.inline} ${className}`}>
      <CopyToClipboard text={url} className={`${shared.action}`} onCopy={onCopy}>
        <Body1>
          <Icon data-testid="wws-url-copy-icon" name="copy" />
          {copyCta}
        </Body1>
      </CopyToClipboard>
    </div>
  );
};

export default UrlCopy;
